import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	server: {
		SMTP_HOST: z.string().min(1).optional(),
		SMTP_PORT: z.coerce.number().int().positive().default(465),
		SMTP_USER: z.string().min(1).optional(),
		SMTP_PASS: z.string().min(1).optional(),
		CONTACT_TO_EMAIL: z.email().optional(),
		CONTACT_FROM_EMAIL: z.string().min(1).optional(),
	},
	clientPrefix: "VITE_",
	client: {
		VITE_ANALYTICS_ENABLED: z
			.enum(["true", "false"])
			.default("true")
			.transform((value) => value === "true"),
		VITE_POSTHOG_KEY: z.string().min(1).optional(),
		VITE_POSTHOG_HOST: z.string().url().optional(),
	},
	runtimeEnv: {
		...import.meta.env,
		...process.env,
	},
	emptyStringAsUndefined: true,
});
